module.exports = __webpack_public_path__ + "static/img/zhongxue.1acb8f40.png";